import { Component, Prop, Vue } from 'vue-property-decorator';
import { Acreditacion } from '@conacyt/historicopersonasms-client';
import * as dateUtils from '@/shared/date/date-utils';
import * as formatterUtils from '@/shared/formatter/formatter-utils';

import HistoryItemComponent from '@/components/expediente-persona/history-item/history-item.vue';

@Component({
  components: {
    'history-item': HistoryItemComponent,
  },
})
export default class AcreditacionesComponent extends Vue {
  @Prop({ required: false })
  public item: Array<Acreditacion>;

  get acreditaciones(): Array<Acreditacion> {
    if (!this.item) return this.item;

    return [...this.item].sort((a, b) => {
      const aInicio = Date.parse(a.vigencia.fechaInicio);
      const bInicio = Date.parse(b.vigencia.fechaInicio);
      const aFin = Date.parse(a.vigencia.fechaFin);
      const bFin = Date.parse(b.vigencia.fechaFin);

      const activoCompare = Number(b.activoVigente) - Number(a.activoVigente);
      if (activoCompare !== 0) return activoCompare;

      const fechaInicioCompare = bInicio - aInicio;
      if (fechaInicioCompare !== 0) return fechaInicioCompare;

      return bFin - aFin;
    });
  }

  get fields() {
    return [
      { key: 'activoVigente', label: 'Vigencia activa', sortable: true },
      { key: 'remunerado', label: 'Remunerado', sortable: true },
      { key: 'tipo.descripcion', label: 'Situación', sortable: true },
      { key: 'tipificacion.descripcion', label: 'Tipo de programa', sortable: true },
      { key: 'institucion.tipoInstitucionDesc', label: 'Tipo de institución', sortable: true },
      { key: 'institucion.tipoInstitucionNivelUNODesc', label: 'PÚBLICA / PRIVADA', sortable: true },
      { key: 'institucion.descripcion', label: 'Institución', sortable: true },
      { key: 'institucion.dependenciaDesc', label: 'Dependencia', sortable: true },
      { key: 'institucion.subDependenciaDesc', label: 'Sub dependencia', sortable: true },
      { key: 'institucion.departamentoDesc', label: 'Departamento', sortable: true },
      { key: 'tipoParticipacion', label: 'Tipo de participación', sortable: true },
      {
        key: 'vigencia.fechaInicio',
        label: 'Fecha de inicio',
        sortable: true,
        formatter: value => dateUtils.formatUtc(value),
      },
      {
        key: 'vigencia.fechaFin',
        label: 'Fecha de fin',
        sortable: true,
        formatter: value => dateUtils.formatUtc(value),
      },
      { key: 'estadoSolicitud', label: 'Estado solicitud', sortable: true },
      {
        key: 'documento.idContentManagment',
        label: 'Documento',
        sortable: true,
        linkComprobante: true,
        formatter: value => formatterUtils.legacyLinkFormatter(value),
      },
      {
        key: 'informe.fechaCreacion',
        label: 'Fecha de firma del informe mensual',
        sortable: true,
        formatter: value => dateUtils.formatUtc(value),
      },
    ];
  }

  mounted() {
    this.mostrarAcreditacionActiva();
  }

  /*
   * Compara las fechas de cada acreditacion y agrega como activa la mas reciente,
   * independientemente del index que se ubique
   */
  public mostrarAcreditacionActiva() {
    if (!this.acreditaciones || this.acreditaciones.length === 0) {
      return;
    }

    const hoy = new Date();

    // Calcular la diferencia de cada registro respecto a la fecha actual
    let indiceMasCercano = 0;
    let diferenciaMasCercana = Number.MAX_SAFE_INTEGER;
    this.acreditaciones?.forEach((acreditacion, index) => {
      const diferenciaActual = Math.abs(new Date(acreditacion.informe?.fechaCreacion).getTime() - hoy.getTime());

      if (diferenciaActual < diferenciaMasCercana) {
        diferenciaMasCercana = diferenciaActual;
        indiceMasCercano = index;
      }
    });

    this.acreditaciones.forEach(a => (a.activoVigente = false));

    // Marcar solo el más cercano como activo
    this.acreditaciones[indiceMasCercano].activoVigente = true;
  }
}
